export default __webpack_public_path__ + "static/media/two-o-clock.5f10221f.png";